import { createFileRoute } from '@tanstack/react-router';
import CheckForm from '../../../../../../components/RefundUIs/CheckForm';

export const Route = createFileRoute(
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/check',
)({
  component: CheckPayment,
});

function CheckPayment() {
  return <CheckForm />;
}
